'use strict';

$(document).ready(function () {
    const $carousels = $('.slick-carousel');
    $carousels.each((i, carousel) => {
        const $carousel = $(carousel);
        const $wrapper = $carousel.find('.carousel-wrapper');

        const customSettings = $carousel.data('settings');

        const settings = {
            ...customSettings,
        };

        $wrapper.on('initSlick', function () {
            if (!$wrapper.hasClass('slick-initialized') && !app.isDesktop()) {
                $wrapper.slick(settings);
            }
        });
    });
});
